var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-set"},[_vm._l((_vm.headerSet),function(header,headIdx){return [_c('column-description',{key:`description-${headIdx}`,attrs:{"column":header}}),(headIdx < _vm.headerSet.length - 1)?_c('div',{key:`or-${headIdx}`,staticClass:"or"},[_vm._v(" OR ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }